<template>
  <b-sidebar
    id="sidebar-create-notification"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t(notification.id ? 'Update' : 'Create') }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="notificationCreate">

          <!-- Subject -->
          <b-form-group
            :label="$t('Subject')"
            label-for="subject"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Subject')"
              rules="required"
            >
              <b-form-input
                id="subject"
                v-model="notification.subject"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Body -->
          <b-form-group
            :label="$t('Body')"
            label-for="body"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Body')"
              rules="required"
            >
              <b-form-textarea
                id="body"
                v-model="notification.body"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- File -->
          <b-form-group
            :label="$t('File')"
            label-for="file"
          >
            <div
              v-if="notification.file"
              class="input-group"
            >
              <div class="input-group-prepend">
                <span class="input-group-text border-success">
                  <b-link
                    :href="notification.file"
                    download="file"
                    target="_blank"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      class="cursor-pointer"
                      size="16"
                    />
                  </b-link>

                </span>
              </div>
              <div
                class="form-control border-success"
              >
                {{ $t('File') }}
              </div>
              <div
                class="input-group-append"
              >
                <span class="input-group-text">
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer danger"
                    size="16"
                    @click="cancel"
                  />
                </span>
              </div>
            </div>
            <validation-provider
              v-else
              #default="{ errors }"
              :name="$t('File')"
              rules="file-size:10"
            >
              <b-form-file
                v-model="notification.file_upload"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="notification.id ? 'primary' : 'success'"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t(notification.id ? 'Update' : 'Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormTextarea,
  BFormInput, BFormFile, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, fileSize } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormTextarea,
    BFormInput,
    BFormFile,
    BLink,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      fileSize,
    }
  },
  computed: {
    notification: {
      get() {
        return this.$store.state[this.MODULE_NAME].notification
      },
      set(data) {
        this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
      },
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.$store.commit('notification/FRESH')
      this.$refs.notificationCreate.reset()
      hide()
    },
    cancel() {
      this.notification.file = null
      this.notification.file_upload = null
    },
    submit(hide) {
      this.$refs.notificationCreate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.notification, `${this.MODULE_NAME}/create`, () => {
            this.$emit('refetchData')
            this.$store.commit('notification/FRESH')
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'notification'
    return {
      MODULE_NAME,
    }
  },
}
</script>
